export default "__VITE_ASSET__bmII6aSj__"